import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { useFormWidth } from '@components/forms/FinalForm/context'
import { FormElement } from '@components/forms/Input'
import { ThemeProvider } from '@contexts/ThemeProvider'
import { EncounterType, encounterDateField } from '@hb/shared'
import { CSSProperties } from 'react'
import { useEncounterForm } from '../EncounterFormProvider'

const style: CSSProperties = {
  border: '1px solid #00000050',
  backgroundColor: 'white',
  minWidth: 'auto',
}

export const EncounterDateInput = () => {
  const { mobileLayout } = useFormWidth()
  const { type, includePreVisitContact, setIncludePreVisitContact } = useEncounterForm()
  const isAntepartum = type === EncounterType.ANTEPARTUM
  return (
    <Flex
      flexFlow={mobileLayout ? 'column' : 'row'}
      flex={1}
      minW={0}
      gap={mobileLayout ? 0 : 2}
      align={mobileLayout ? 'flex-start' : 'center'}>
      <ThemeProvider placeholderAbove={false} theme="basic">
        <Flex align="center" flex={1} gap={2} minW={0} flexWrap="wrap">
          <Text fontSize="sm" fontWeight={500} whiteSpace="nowrap">
            Encounter Date:
          </Text>
          <FormElement
            showName={false}
            style={style}
            field={encounterDateField}
            size="sm"
            name="date"
          />
          {/* On mobile the pre-visit link renders in the header's action-button row instead */}
          {isAntepartum && !includePreVisitContact && !mobileLayout && (
            <Box pl={1}>
              <Button
                variant="link"
                fontSize="14px"
                colorScheme="gray"
                fontWeight={400}
                onClick={() => setIncludePreVisitContact(true)}>
                + Add pre-visit contact
              </Button>
            </Box>
          )}
        </Flex>
      </ThemeProvider>
    </Flex>
  )
}
